/* Newsletter acceptance measurement. No email or other customer data is read. */
(() => {
  'use strict';
  if (window.Shopify?.designMode) return;

  const key = 'soso_newsletter_pending_v1';
  const maxAge = 30 * 60 * 1000;
  const forms = Array.from(document.querySelectorAll('form[data-newsletter-form]'));
  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  };
  const clear = () => {
    try { sessionStorage.removeItem(key); return true; } catch { return false; }
  };

  // Preserve Shopify's native POST, validation and bot protection.
  forms.forEach((form) => {
    const email = form.querySelector('input[type="email"]');
    const message = form.querySelector('[data-newsletter-validation]');
    if (!email || !message) return;
    email.addEventListener('invalid', () => {
      message.hidden = false;
      email.setAttribute('aria-invalid', 'true');
    });
    email.addEventListener('input', () => {
      message.hidden = true;
      email.removeAttribute('aria-invalid');
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!forms.includes(form)) { clear(); return; }
    // Shopify's bot challenge may temporarily prevent the native submit.
    // Remember the attempt; only the successful return can emit an event.
    if (!form.checkValidity()) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({
        form: form.id,
        placement: form.dataset.newsletterForm,
        at: Date.now()
      }));
    } catch { /* Submission still works when storage is unavailable. */ }
  }, true);

  const pending = read();
  if (!pending) return;
  const age = Date.now() - pending.at;
  if (!Number.isFinite(age) || age < 0 || age > maxAge) { clear(); return; }
  const form = forms.find((item) => item.id === pending.form);
  if (!form || location.hash !== '#' + form.id) return;
  const error = form.querySelector('[data-newsletter-error]');
  if (error) { clear(); error.focus(); return; }
  // Liquid renders this marker only for Shopify's successful form response.
  // A recent submission in this tab and the matching form anchor are also required.
  if (!form.querySelector('[data-newsletter-success]')) return;
  if (!clear()) return; // Fail closed so a reload cannot replay the event.

  let sent = false;
  let timer;
  let tries = 0;
  const send = () => {
    if (sent || Date.now() - pending.at > maxAge) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' ||
        !privacy.analyticsProcessingAllowed() || typeof window.gtag !== 'function') return;
    sent = true;
    clearTimeout(timer);
    document.removeEventListener('visitorConsentCollected', send);
    // Reuse the existing Google tag; do not install or configure another tag.
    window.gtag('event', 'newsletter_signup', {
      send_to: 'G-35DFC8VGBV',
      method: 'email',
      form_id: form.id,
      form_location: pending.placement,
      language: document.documentElement.lang,
      transport_type: 'beacon'
    });
  };
  document.addEventListener('visitorConsentCollected', send);
  const retry = () => {
    send();
    if (!sent && ++tries < 30) timer = setTimeout(retry, 500);
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => { if (!error) send(); });
  }
  retry();
  window.addEventListener('pagehide', () => {
    clearTimeout(timer);
    document.removeEventListener('visitorConsentCollected', send);
  }, { once: true });
})();
